import { TypedDocumentNode } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { MobileOpCode, Query } from 'graphql/generated/graphqlTypes';
import { GET_ACCESS_EVENTS_FOR_TENANT } from 'graphql/v2/queries';
import { BaseHookProps } from 'hooks/shared/types';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { useEffect } from 'react';

// Typing the documents (instead of passing generics to the Apollo hooks) avoids the deprecated hook signatures.
const GET_ACCESS_EVENTS_FOR_TENANT_TYPED: TypedDocumentNode<Pick<Query, 'getAccessEventsForTenant'>> =
  GET_ACCESS_EVENTS_FOR_TENANT;

interface Props extends BaseHookProps {
  deviceId: string;
}

const useDeviceDetailsAccessEvents = ({ handleFetchError, deviceId }: Props) => {
  const { translation } = useTranslation();

  const {
    loading: accessEventsLoading,
    error: accessEventsError,
    data: accessEventsData
  } = useQuery(GET_ACCESS_EVENTS_FOR_TENANT_TYPED, {
    variables: {
      filter: {
        doorIds: [deviceId],
        actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted]
      }
    }
  });

  useEffect(() => {
    if (accessEventsError) {
      handleFetchError(translation.access_events_error_fetching);
      console.error(accessEventsError);
    }
  }, [accessEventsError]);

  return {
    deviceDetailsAccessEvents: accessEventsData?.getAccessEventsForTenant.items,
    loadingGetDeviceDetailsAccessEvents: accessEventsLoading
  };
};

export default useDeviceDetailsAccessEvents;
